import { render, staticRenderFns } from "./UITextarea.vue?vue&type=template&id=571b811e"
import script from "./UITextarea.vue?vue&type=script&lang=js"
export * from "./UITextarea.vue?vue&type=script&lang=js"
import style0 from "./UITextarea.vue?vue&type=style&index=0&id=571b811e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports